import { Component, inject } from '@angular/core';
import { ButtonComponent } from '../button/button.component';
import { TranslateModule } from '@ngx-translate/core';
import { AuthService } from '@app/auth/auth.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-blocked-modal',
  imports: [ButtonComponent, TranslateModule],
  templateUrl: './blocked-modal.component.html',
  styleUrl: './blocked-modal.component.scss'
})
export class BlockedModalComponent {
  private authService = inject(AuthService);
  public dialogRef = inject(MatDialogRef<BlockedModalComponent>);
  public data = inject(MAT_DIALOG_DATA) as { logout: boolean };

  onContactSupport(){
    this.dialogRef.close();
    this.authService.supportContact();
    if (this.data.logout) {
      setTimeout(() => {
        this.authService.logout().subscribe();
      }, 500);
    }
  }
}
